import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Auth } from 'services/action';

import { Page, Button, Form } from 'ui/components';
// import Tutorial from '../customer/component/tutorial';

const initialState = {
  name: '',
  phone: '',
  password: '',
  confirm_password: '',
};

const ProfileScreen = () => {
  const History = useHistory();
  const Dispatch = useDispatch();

  const hub = useSelector((state) => state?.Auth?.hub);
  const StateForm = useSelector((state) => state.Form);
  // const StateLoading = useSelector(
  //   (state) => state?.Activity?.services['Auth.fetchProfile']
  // );
  const [{ confirm_password, name, password, phone }, setState] =
    React.useState(initialState);

  const $onLoad = async () => {
    const req = await Dispatch(Auth.$fetchProfile());
    if (req?.message === 'success') {
      setState((prevState) => ({
        ...prevState,
        name: req?.data?.user?.name,
        phone: req?.data?.user?.phone,
      }));
    }
  };

  const $handleSubmit = async (e) => {
    const payload = {
      hub_id: hub?.id,
      name,
      phone,
      password,
      confirm_password,
    };

    const update = await Dispatch(Auth.$update(payload));

    if (update?.message === 'success') {
      Dispatch(Auth.$fetchProfile());
    }
  };

  React.useEffect(() => {
    $onLoad();
  }, []);

  return (
    <Page type="form" className="bg-white col-md-8 " onSubmit={$handleSubmit}>
      <Page.Header title="Profile Pengguna" />
      {/* <Page.Navigation>
        <Tutorial />
      </Page.Navigation> */}
      <Page.Body className="px-3 py-3">
        <div className="row ">
          <div className="col-12 col-md-6">
            <Form.Input
              value={name || ''}
              required
              type="text"
              label="Nama"
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  name: e?.target?.value,
                }))
              }
              error={StateForm?.errors?.name}
            />
            <Form.Input
              value={phone || ''}
              type="phone"
              label="Nomor Handphone"
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  phone: e?.target?.value,
                }))
              }
              error={StateForm?.errors?.phone}
            />
          </div>
          <div className="col-12 col-md-6">
            <Form.Input
              value={password}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  password: e?.target?.value,
                }))
              }
              label="Password"
              type="text"
              error={StateForm?.errors?.password}
            />
            <Form.Input
              value={confirm_password}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  confirm_password: e?.target?.value,
                }))
              }
              label="Konfirmasi Password"
              type="text"
              error={StateForm?.errors?.confirm_password}
            />
          </div>
        </div>
      </Page.Body>
      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary px-4 py-3"
          onClick={() => {
            History.replace(`/`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary px-4 py-3"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default ProfileScreen;
